import React, { useState, useEffect } from "react";
import { Button, Modal, Form, Input, Space, Select, message } from "antd";
import { getAllMessage } from "../../../helpers/helper";
import Editor from "../../../common/Editor";
import { useTranslation } from "react-i18next";

const { Option } = Select;

export default function ModalFunction({
  dataGroup,
  isModalFunction,
  setIsModalFunction,
  onFinish,
  form,
  editorContentRef,
  nameRefId,
  content,
  setContent,
  setTypeMessage,
  typeMessage,
}) {
  const [message, setMessage] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    fetchDataMessage();
    if (dataGroup) {
      form.setFieldsValue({
        name: dataGroup?.name,
        groupAndBotId: dataGroup?.key,
      });
    }
  }, [dataGroup]);

  const fetchDataMessage = async () => {
    const res = await getAllMessage();

    if (res) {
      setMessage(res.data.data);
    }
  };

  const handleCancel = () => {
    setIsModalFunction(false);
    form.setFieldsValue({
      typeMessage: 1,
      msgContent: "",
    });
    setTypeMessage(1);
    setContent("");
    editorContentRef.current = "";
  };

  const handleChange = (value) => {
    setTypeMessage(value);
  };

  return (
    <div>
      <Modal
        title={t("sendMess")}
        open={isModalFunction}
        onCancel={handleCancel}
        footer={false}
      >
        <Form
          name="basic"
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: "auto",
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          autoComplete="off"
          form={form}
        >
          <Form.Item hidden label="id" name="groupAndBotId">
            <Input />
          </Form.Item>
          <Form.Item
            label={t("GroupNameTelegram")}
            name="name"
            rules={[
              {
                required: true,
                message: t("validateGroupNameBot"),
              },
            ]}
          >
            <Input allowClear readOnly disabled />
          </Form.Item>

          <Form.Item label={t("messTelegramType")} name="typeMessage">
            <Select
              onChange={handleChange}
              placeholder={t("placeHolderSelectMessType")}
              allowClear
              value={1}
              defaultValue={1}
            >
              <Option key={1} value={1}>
                {t("messagesAreAvailable")}
              </Option>
              <Option key={2} value={2}>
                {t("customMess")}
              </Option>
            </Select>
          </Form.Item>
          {typeMessage === 1 ? (
            <Form.Item
              label={t("messenger")}
              name="messageId"
              rules={[
                {
                  required: true,
                  message: t("validateMessenger"),
                },
              ]}
            >
              <Select
                placeholder={t("placeHolderMessenger")}
                allowClear
                showSearch
              >
                {message?.length > 0 &&
                  message?.map((item) => {
                    return (
                      <Option key={item._id} value={item._id}>
                        {item.name}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          ) : (
            <Form.Item
              label={t("messenger")}
              name="msgContent"
              rules={[
                {
                  required: true,
                  message: t("validateMessengerInputg"),
                },
              ]}
            >
              <Editor
                valueName={content}
                onChange={(v) => (editorContentRef.current = v)}
                refId={nameRefId}
              />
            </Form.Item>
          )}

          <div className="text-right mt-10">
            <Space>
              <Button type="primary" danger onClick={handleCancel}>
                {t("cancel")}
              </Button>
              <Button htmlType="submit" type="primary" className="btn-modal">
                {t("confirm")}
              </Button>
            </Space>
          </div>
        </Form>
      </Modal>
    </div>
  );
}
